module.exports = __webpack_public_path__ + "img/bg-a@2x.5b07779f.png";